import { connectedLiveSections } from 'components/secondaryMarket/live/sections.connect';
import { LivePostEventPricingInformation } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LivePostEventPricingInformation';
import { connectLivePostEventPricingInformation } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LivePostEventPricingInformation.connect';
import { LiveSalesMarginInformationMargin } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LiveSalesMarginInformation';
import { connectLiveSalesMarginInformation } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.ts/LiveSalesMarginInformation.connect';

export const LivePostEventSections = {
  ...connectedLiveSections('secondaryMarketPostEvents'),
  ConnectedPricingInformation: connectLivePostEventPricingInformation(LivePostEventPricingInformation),
  ConnectedLiveSalesMarginInformation: connectLiveSalesMarginInformation(LiveSalesMarginInformationMargin),
};
